import * as actionTypes from "./ActionTypes"
// import { API } from "services/API"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const listsUserUpdate = () => {
  return dispatch => {
    // API("GET", UrlServer.URL_GET_LIST_USER, null, datas => {
    //   console.log("listsUserUpdate >>", datas)
    //   dispatch({ type: actionTypes.LISTS_USER_UPDATE, listsUser: datas.datas })
    // })
    APIGet(UrlServer.URL_GET_LIST_USER, datas => {
      console.log("listsUserUpdate >>", datas)
      dispatch({ type: actionTypes.LISTS_USER_UPDATE, listsUser: datas.datas })
    })
  }
}
